const elements = document.querySelectorAll('.js-seminar-table');

const clickableTableRow = () => {
  if (elements.length === 0) return;

  const addLink = (element) => {
    const anchorList = element.querySelectorAll('table .entry_textbtn a');

    anchorList.forEach(anchor => {
      const href = anchor.href;
      const tr = anchor.closest('tr');
      tr.style.cursor = 'pointer';
      tr.addEventListener('click', () => {
        window.location.href = href;
      });
    });
  };

  elements.forEach(element => {
    addLink(element);
  });
};

const init = () => {
  clickableTableRow();
};

export default init;
